<template>
  <div>

    <v-container grid-list-md>

      <div class="mt-4">
        <span 
        class="title unselectable"
        @click="onTitleClick">
          Settings
        </span>
      </div>

      <v-card class="pa-4 mt-4">

        <!-- mobile or desktop icon -->
        <div v-if="$vuetify.breakpoint.xs" class="color1--text">
          <v-icon small color="color1">phone_iphone</v-icon>
          Mobile version
        </div>
        <div v-else class="color1--text">
          <v-icon small color="color1">computer</v-icon>
          Desktop version
        </div>

        <v-subheader class="pl-0 mb-4">Decimal Accuracy</v-subheader>
        <v-slider
        color="color1"
          v-model="decimalAccuracy"
          thumb-label="always"
          max="15"
          min="0"
        ></v-slider>  

        <!-- HIDDEN -->
        <div v-if="showHidden">

          <v-flex>
            <v-subheader class="pl-0">Debug mode</v-subheader>
            <v-switch
              v-model="debugMode"
              :label="debugMode ? 'on' : 'off'"
              color="color1"
              hide-details
            ></v-switch>
          </v-flex>

          <v-flex>
            <v-card outlined class="elevation-0 mt-2 mb-2">
              <v-card-text>
                Migration

                <v-text-field
                placeholder="password"
                v-model="migratePassword">
                </v-text-field>

                <v-btn
                class="color1 white--text"
                :loading="migrationRunning"
                @click.shift="migrate">
                  Shift click to Migrate
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex>
            <v-subheader class="pl-0 mb-4">Currency</v-subheader>
          </v-flex>

          <v-btn @click.stop="extraDrawer = !extraDrawer" outlined>
            Open extra drawer
          </v-btn>

        </div>

      </v-card>

      <v-card class="mt-4">
        <settings-table></settings-table>

        {{ $store.state.settings }}
      </v-card>
    </v-container>
  </div>
</template>

<script>
import SettingsTable from './settings-table'

export default {
  components: {
    SettingsTable
  },
  data () {
    return {
      showHidden: false,
      migratePassword: '',
      titleClicks: 0,
      titleTimer: null,
      migrationRunning: false
    }
  },
  computed: {
    decimalAccuracy: {
      get () {
        return this.$store.state.settings.decimalAccuracy
      },
      set (val) {
        this.$store.commit('settings/SET_DECIMAL_ACCURACY', val)
      }
    },
    debugMode: {
      get () {
        return this.$store.state.settings.debugMode
      },
      set (val) {
        this.$store.commit('settings/SET_DEBUG_MODE', val)
      }
    },
    extraDrawer: {
      get () {
        return this.$store.state.navRightExtra
      },
      set (val) {
        this.$store.commit('openNavRightExtra', val)
      }
    }
  },
  methods: {
    migrate () {
      this.migrationRunning = true
      this.$axios.post('migrate',
        {password: this.migratePassword},
        {headers: {'Content-Type': 'application/json'}})
        .then(response => {
          console.log(response)
          alert('Successfull migration. Check console for response data')
        })
        .catch(error => {
          console.log(error.response)
          alert(error.response.data.errors)
        })
        .then(() => {
          this.migrationRunning = false
        })
    },
    onTitleClick () {
      if (!this.$accessControl.userHasAccess(0, this.$store.state.auth.accessControl)) {
        return
      }

      this.titleClicks++

      clearTimeout(this.titleTimer)
      this.titleTimer = setTimeout(this.titleTimerComplete, 1000)

      if (this.titleClicks >= 3 & !this.showHidden) {
        this.showHidden = true
        this.titleClicks = 0
      } else if (this.showHidden) {
        this.showHidden = false
        this.titleClicks = 0
      }
    },
    titleTimerComplete () {
      this.titleClicks = 0
    }
  }
}
</script>
